define('SuiteCommerce.OrderStatus.Common.DependencyProvider', [
    'underscore',
    'GlobalViews.Message.View'
  ],
  function(
    _,
    MessageView) {
    'use strict';
    function isTranspiledModule(module) {
      var moduleKeys = Object.keys(module);
      return !_.isFunction(module) && moduleKeys.length === 1;
    }
    function getDependency(module) {
      if (isTranspiledModule(module)) {
        return module[Object.keys(module)[0]];
      }
      return module;
    }
    return {
      MessageView: getDependency(MessageView)
    };
  });
